<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-top:200px">Dedication</h1>
<p style="text-align:center">To my lovely, warm-hearted and talented daughters:</p>
<p style="text-align:center">Marianne (Nanne) and Ninne.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?c191d93a